import { render, staticRenderFns } from "./ContractDetailCard.vue?vue&type=template&id=cb211450&"
import script from "./ContractDetailCard.vue?vue&type=script&lang=ts&"
export * from "./ContractDetailCard.vue?vue&type=script&lang=ts&"
import style0 from "./ContractDetailCard.vue?vue&type=style&index=0&id=cb211450&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports